import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';


/**
 * Displays the Why Outdoor Access and FAQ Section that is displayed on
 * several onboarding workflow component steps such as:
 *  OfferComponent (Direct Mail Landowner Onboarding)
 *  IntakeFinishComponent (Landowner Onboarding)
 *
*/
interface WhyOACopy {
  title: string;
  content: string;
}
@Component({
    selector: "onboard-why-oa",
    templateUrl: "./onboard-why-oa.component.html",
    styleUrls: ["./onboard-why-oa.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class OnboardWhyOAComponent implements OnInit {
  private readonly _componentName = 'OnboardWhyOAComponent';
  private _scheduleUrl: string;
  
  whyOACard: WhyOACopy[];

  constructor() {
  this.whyOACard = [
    {title: 'Flexibility',
    content:"Make your property available only when it's convenient for you. There is no cost or commitment to list any property, big or small.",
    },
    {title:'Control',
      content:'You decide what is allowed on your property and when. Our members love all sorts of outdoor activities like hunting, fishing, camping & more.',
    },
    {title:'Peace of Mind',
      content:'$3M insurance policy included. Outdoor Access provides background checks for all guests, so you don’t have to worry.',
    }
  ]
  }
  
  ngOnInit() {
  }

  public get scheduleUrl(): string {
    return this._scheduleUrl;
  }

  @Input()
  public set scheduleUrl(v: string) {
    this._scheduleUrl = v;
  }
}
